export default "__VITE_ASSET__stdTaw3Q__"